import { render, staticRenderFns } from "./ApplicantBusinessDocuments.vue?vue&type=template&id=4fd5f516&"
import script from "./ApplicantBusinessDocuments.vue?vue&type=script&lang=js&"
export * from "./ApplicantBusinessDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantBusinessDocuments.vue?vue&type=style&index=0&id=4fd5f516&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports